var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: _vm.dialog, "max-width": "450" },
      on: {
        "click:outside": _vm.close,
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("Desvincular Legajo"),
          ]),
          _vm.legajo
            ? _c(
                "v-card-text",
                { staticClass: "pt-3" },
                [
                  _c("p", { staticClass: "fs-16 mb-5" }, [
                    _vm._v(" ¿Desea desvincular a "),
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.legajo.name) +
                          " " +
                          _vm._s(_vm.legajo.surname)
                      ),
                    ]),
                    _vm._v(
                      " (Legajo N° " + _vm._s(_vm.legajo.nro_legajo) + ")? "
                    ),
                  ]),
                  _c("BaseDatePicker", {
                    attrs: {
                      label: "Fecha de desvinculación",
                      name: "finish_date",
                      rules: "required",
                      validationErrors: _vm.errors,
                    },
                    model: {
                      value: _vm.finish_date,
                      callback: function ($$v) {
                        _vm.finish_date = $$v
                      },
                      expression: "finish_date",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "red darken-1",
                    text: "",
                    disabled: _vm.loading,
                  },
                  on: { click: _vm.close },
                },
                [_vm._v("Cancelar")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "green darken-1",
                    text: "",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.confirm },
                },
                [_vm._v("Desvincular")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }